import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as OfficeContracts from './Saga/OfficeContracts';
import OfficeContractsGrid from "./OfficeContractsGrid";
import Search from "./Search";
import moment from 'moment'

// import { customerList,  customerNewDispSet } from '../../Store/Customers';

interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_rent_contracts_list: any,
    search_detail: any,
}



interface State {

    // state types
}


class CustomerList extends Component<Props, State> {

    constructor(props: Readonly<Props>) {

        super(props);
        this.state = {
            modal: false,
            modal_contacts: false,
            modal_replace: false,
            // modalselect: false,
            change: false,
            search: '',


        };

        this.props.get_rent_contracts_list()
    }




    componentWillMount() {
        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        // this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    // submit(state: any) {
    //     console.log(state)

    //     // this.props.get_rent_contracts(state)
    // }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div >
                {/* <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse}
                    <div className="item">
                        <ContractSearchForm />

                    </div>

                </div> */}


                <div style={{margin:3, paddingLeft:3, paddingRight:3, paddingTop:10}} className="item"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="" style={{float:"left"}}>
                        <Search />
                    </div>
                    <div className="" style={{float:"left", marginLeft:3}}>
                        <OfficeContractsGrid />
                    </div>
                </div>
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        // search_detail: state.kyousaiReducer.search_detail,

        rent_contract_list: state.OfficeContracts.rent_contract_list

    }
}
function mapDispatchToProps(dispatch: any) {
    return {

        get_rent_contracts_list(state: any) {
            dispatch(OfficeContracts.get_rent_contracts_list(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




